import { LoggerService } from './../../services/logger.service';
import { StaffAuthService } from './../../services/staff-auth.service';
import { AppMessages } from 'app/shared/consts/app-messages';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Component, OnInit, EventEmitter, Output, ElementRef, ViewChild, Input } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import * as _ from 'lodash';

declare var Swiper: any;
declare var $: any;
@Component({
  selector: 'camera-standard',
  templateUrl: './camera-standard.component.html',
  styleUrls: ['./camera-standard.component.scss'],
})
export class CameraStandardComponent implements OnInit {
  @ViewChild('canvas', { static: true }) canvas: ElementRef;
  @Output()
  public captureEvent = new EventEmitter<string>();
  @Output()
  public offCameraEvent = new EventEmitter();
  @Input()
  public cancelableCamera: boolean = false;
  public webcamImage: WebcamImage;
  public isShowWebcam : boolean = true;
  private trigger: Subject<void> = new Subject<void>();
  public showGuide: boolean = false;
  public showRightCapture: boolean = false;
  public showWrongCapture: boolean = false;
  public showMessageBox: boolean = false;
  public message: string;
  public allowUpload: boolean = false;

  constructor(
    private staffService: StaffAuthService, 
    private loggerService: LoggerService) {
    }
  public videoOptions: MediaTrackConstraints = {
    width: {
        min: 1280
    },
    height: {
        min: 720
    },
    facingMode: {
        exact: "environment"
    }
  };
  ngOnInit() {
    if(this.staffService.currentCampaignConfig.allowUploadImage)
    {
      this.allowUpload = true;
    }
  }

  public cameraHandleError(error: WebcamInitError): void
  {
    if (error.mediaStreamError && error.mediaStreamError.name === "NotAllowedError") {
      console.warn("Camera access was not allowed by user!");
      this.message = AppMessages.NOT_ACCESS_CAMERA;
      this.showMessageBox = true;
    }
    try{
      if(error)
      {
        var jsonText = JSON.stringify(error);
        this.loggerService.logger(jsonText, 'UgiftCamera');
      }
    }catch(ex)
    {
      console.error('Logger Error');
    }
  }
  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.cropImage(this.webcamImage.imageAsDataUrl);
  }


  private cropImage(image: string): void
  {
    var pictureBill = document.getElementById('imageContainer');
    var width = $(pictureBill).css('width').replace('px','');
    var height = $(pictureBill).css('height').replace('px','');
    var containerRate = parseFloat(height)/parseFloat(width);
    var realImgHeight = containerRate * 720;
    var realY = (1280 - realImgHeight)/2;
    var canvas: any = document.getElementById('canvasx');
    canvas.height = realImgHeight;
    canvas.width = 720;
    var ctx = canvas.getContext('2d');
    var img = new Image;
    var base = this;
    img.onload = function(){
        ctx.drawImage(img,0,parseInt(realY + ''), 720, realImgHeight, 0,0, 720, realImgHeight);
        base.captureEvent.emit(canvas.toDataURL("image/jpeg"));
    };
    img.src = image;
  }

  public uploadImage(): void
  {
    $('.fileInputProfile').trigger('click');
  }

  public fileChangeEvent(fileInput: any): void {
    if (fileInput.target.files && fileInput.target.files[0]) {
        // Max f
        let max_size = 2097152;
        if(this.staffService.currentCampaignConfig 
          && this.staffService.currentCampaignConfig.maxUploadSize 
          && this.staffService.currentCampaignConfig.maxUploadSize > 0)
        {
          max_size = this.staffService.currentCampaignConfig.maxUploadSize;
        }
        const allowed_types = ['image/png', 'image/jpg', 'image/jpeg'];
        if (fileInput.target.files[0].size > max_size) {
          this.showMessageBox = true;
          this.message = AppMessages.INVALID_FILE_SIZE + " (Tối đa " + (max_size/1024/1024) + 'MB)'
          return;
        }
        if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
          this.showMessageBox = true;
          this.message = AppMessages.INVALID_FILE;
          return;
        }

        const reader = new FileReader();
        reader.onload = (e: any) => {
            const image = new Image();
            image.src = e.target.result;
            image.onload = rs => {
              const imgBase64Path = e.target.result;
              this.captureEvent.emit(imgBase64Path);
            };
        };
        reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public captureImage(){
    this.trigger.next();
  }

  public offCamera():void{
    if(this.cancelableCamera)
    {
      this.offCameraEvent.emit();
    }
  }

  public initSwiper(): void
  {
    var mySwiper = new Swiper('.swiper-container');
  }

  public closeMessagePopupEvent(code: any): void
  {
    this.showMessageBox = false;
  }
}
